// extracted by mini-css-extract-plugin
export var pillWrapper = "_oa-0";
export var showOverflow = "_oa-1";